var _line, _line2, _rect, _line3, _line4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 22,
    y2: 20
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 20,
    x2: 48,
    y2: 20
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 48,
    height: 24,
    rx: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 26,
    x2: 20,
    y2: 38
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 32,
    x2: 26,
    y2: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 27,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 32,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 37,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameController);
export default __webpack_public_path__ + "static/media/game-controller.737d2768e9cee2556ef951b7a74d29c1.svg";
export { ForwardRef as ReactComponent };